import { useRef } from 'react';

export const useHandleUnmount = () => useRef(false);
